import { render, staticRenderFns } from "./reo_table_markets.vue?vue&type=template&id=78dc134e&scoped=true&"
import script from "./reo_table_markets.vue?vue&type=script&lang=js&"
export * from "./reo_table_markets.vue?vue&type=script&lang=js&"
import style0 from "./reo_table_markets.vue?vue&type=style&index=0&id=78dc134e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dc134e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCheckbox,VDataTable,VIcon,VTooltip})
